import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  personList: [],
  areaName: "",
  modelName: "",
};

const violationSlice = createSlice({
  name: "violationSlice",
  initialState,
  reducers: {
    savePersonList: (state, action) => {
      state.personList = action.payload;
    },
    clearPersonList: (state) => {
      state.personList = [];
    },
    saveArea: (state, action) => {
      state.areaName = action.payload;
    },
    saveModel: (state, action) => {
      state.modelName = action.payload;
    },
    clearArea: (state) => {
      state.areaName = "";
    },
    clearModel: (state) => {
      state.modelName = "";
    },
  },
});

export const { savePersonList, clearPersonList, saveArea, saveModel, clearArea, clearModel } = violationSlice.actions;
export default violationSlice.reducer;
